const trains = {
  train: "電車", // translated
  trains: "電車", // translated
  fairConditions: "公正な条件", // translated
  to: "に", // translated
  earlier: "以前", // translated
  later: "後で", // translated
  adults: "大人", // translated
  child: "子供", // translated
  senior: "シニア", // translated
  seniors: "シニア", // translated
  price: "価格", // translated
  for: "のために", // translated
  total: "合計", // translated
  selected: "選択済み", // translated
  prebook: "事前予約", // translated
  book: "本", // translated
  payment: "支払い", // translated
  return: "戻る", // translated
  passengers: "乗客", // translated
  delivery: "配達", // translated
  summary: "まとめ", // translated
  checkout: "チェックアウト", // translated
  trainToastCorrectFillForm: "すべてのフィールドに正しく入力してください。", // translated
  fareConditions: "運賃条件", // translated
  travelInfo: "旅行情報", // translated
  remarks: "お客様の声", // translated
  noServices: "サービスなし", // translated
  timesAndSeats: "時間と座席", // translated
  mobileTicket: "モバイルチケット", // translated
  stationTicket: "駅集合", // translated
  homeTicket: "自宅で印刷", // translated
  countryCode: "国コード", // translated
  chooseTicket: "チケットの配送方法を選択してください", // translated
  ticketError: "すべての目的地の航空券を選択してください", // translated
  ticketDelivery: "チケットの配送方法を選択してください", // translated
  passengerDetails: "乗客の詳細", // translated
  waitWhileProcessingPayment: "お支払いを処理するまでお待ちください。ページを更新したり閉じたりしないでください。", // translated
  reductionCardId: "還元カードID", // translated
  countryOfResidence: "居住国", // translated
  countryOfBirth: "生まれた国", // translated
  documentCountry: "文書の国", // translated
  documentNumber: "書類番号", // translated
  expirationDate: "有効期限", // translated
  documentType: "ドキュメントタイプ", // translated
  travelerDocumentInfo: "渡航者文書情報", // translated
  youth: "若者", // translated
  youths: "若者", // translated
  departTimeEarlyFirst: "出発時刻（早い順）", // translated
};


export default trains;
